import { CommonModule } from "@angular/common";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

const ANGULAR_MATERIAL = [MatIconModule, MatButtonModule, MatDialogModule];

@Component({
  selector: "terra-dialog-header",
  standalone:true,
  imports: [CommonModule,
    ...ANGULAR_MATERIAL],
  templateUrl: "./dialog-header.component.html",
  styleUrls: ["./dialog-header.component.scss"],
})
export class DialogHeaderComponent {
  @Input()
  showCloseButton = true;

  @Input()
  bottomMargin = true;

  @Input()
  closeButtonReturnValue = undefined;

  @Output()
  onCloseRequested = new EventEmitter();

}
